var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientname({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 19.25V17.4167C18.3337 16.4442 17.9473 15.5116 17.2597 14.8239C16.5721 14.1363 15.6395 13.75 14.667 13.75H7.33366C6.3612 13.75 5.42857 14.1363 4.74093 14.8239C4.0533 15.5116 3.66699 16.4442 3.66699 17.4167V19.25",
    stroke: "#5C5CAB",
    strokeOpacity: 0.3,
    strokeWidth: 1.96087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 10.0834C13.0247 10.0834 14.6663 8.44174 14.6663 6.4167C14.6663 4.39165 13.0247 2.75003 10.9997 2.75003C8.97463 2.75003 7.33301 4.39165 7.33301 6.4167C7.33301 8.44174 8.97463 10.0834 10.9997 10.0834Z",
    stroke: "#5C5CAB",
    strokeOpacity: 0.3,
    strokeWidth: 1.96087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientname);
export default __webpack_public_path__ + "static/media/patientname.ded39014095f43017365652bd5ba8e80.svg";
export { ForwardRef as ReactComponent };